
function AdvisedLearning() {
  return (
    <section
        className="container-fluid p-5 text-center text-white position-relative" style={{ zIndex: '-2', backgroundColor: "#212239" }}
      >
        <h1>
          Advised <strong style={{ color: "#7e56d8" }}>Reading</strong>
        </h1>
        <p className="fs-6">
          https://www.wordbank.com/uk/blog/consumer-behaviour-in-uae/
        </p>
        <p className="fs-6">https://files.eric.ed.gov/fulltext/EJ1056632.pdf</p>
        <p className="fs-6">
          http://cime.ac.in/assignment/Modules/MBA/4th_sem/b2b/Mod%20IL.pdf
        </p>
        <p className="fs-6">
          https://www.worldwidejournals.com/indian-journal-of-applied-research-(WJAR)/recentissues
          _pdf/2016/May/May 2016 1492148888 _138.pdf
        </p>
        <p className="fs-6">
          https://nanopdf.com/download/behavioral-segmentation-tm_pdf
        </p>
      </section>
  );
}

export default AdvisedLearning;
